<!-- Mobile burger drawer: navigation + profile -->
<ng-template #mobileMenu let-offcanvas>
  <div class="med_drawer-header d-flex align-items-center justify-content-between">
    <div class="d-flex align-items-center gap-2">
      <span class="med_logo-tile d-flex align-items-center justify-content-center">
        <img src="assets/images/m.svg" alt="" />
      </span>
      <img src="assets/images/edullar.svg" alt="Medullar" />
      <p class="s-body small text-white m-0">v{{ appVersion }}</p>
    </div>
    <button type="button" class="btn btn-link" [attr.aria-label]="'close' | translate" (click)="offcanvas.dismiss()">
      <app-icon icon="xmark" class="icon-light" />
    </button>
  </div>
  <app-main-menu [drawerMode]="true" (onCloseMenuMobile)="offcanvas.dismiss()"></app-main-menu>
</ng-template>
<!-- #Mobile burger drawer -->

<header class="med_global-header d-flex flex-column">
  <div class="med_global-header-bar d-flex align-items-center gap-3">
    @if (showFullHeader && !deviceType.isDesktop) {
    <button
      type="button"
      class="med_header-icon-btn"
      [attr.aria-label]="'menu' | translate"
      data-cy="med_header_burger"
      (click)="toggleMobileMenu()">
      <app-icon icon="bars" class="icon-light" />
    </button>
    }

    <!-- Hidden on mobile to leave room for the workspace pill, except on auth
         routes where the logo is the only thing in the bar. -->
    <!-- @if (!deviceType.isMobile || !showFullHeader) { -->
    <button
      type="button"
      class="med_logo-tile d-flex align-items-center justify-content-center"
      [class.cursor-default]="isAuthRoute"
      aria-label="Medullar"
      [disabled]="isAuthRoute"
      data-cy="med_header_logo"
      (click)="goHome()">
      <img src="assets/images/m.svg" alt="Medullar" />
    </button>
    <!-- } -->

    @if (showFullHeader) {
    <app-manage-workspace-popup data-cy="med_header_workspace_switcher"></app-manage-workspace-popup>

    <div class="flex-grow-1"></div>

    <!-- Mobile reaches feedback through the burger drawer instead. -->
    @if (deviceType.isDesktop || deviceType.isTablet) {
    <button
      type="button"
      class="med_header-icon-btn"
      [matTooltip]="'help' | translate"
      [attr.aria-label]="'help' | translate"
      data-cy="med_header_help"
      (click)="openDocumentation()">
      <app-icon icon="circle-question" class="icon-light" />
    </button>
    }

    <!-- <app-notifications-panel></app-notifications-panel> -->

    @if (isEmbeddedInExtension) {
    <button
      type="button"
      class="med_header-icon-btn"
      [matTooltip]="'close_extension' | translate"
      [attr.aria-label]="'close_extension' | translate"
      data-cy="med_header_close_extension"
      (click)="closeExtension()">
      <app-icon icon="xmark" class="icon-light" />
    </button>
    }

    <app-popover id="profile_popover" class="med_header-profile" variant="avatar"></app-popover>
    }
  </div>

  <!-- Corporate gradient line, doubling as the search progress indicator -->
  <div class="med_gradient-line position-relative">
    @if (searchService.searching()) {
    <div class="med_loader-line"></div>
    }
  </div>
</header>
